export const REPORTS = [
  {
    id: "order-count",
    title: "Order Count Report",
    description:
      "Track order volumes, weekly trends, institution vs branch mix, and product breakdown by manufacturing branch.",
    path: "/reports/order-count",
    icon: "bar-chart",
    accent: "#6366f1",
    available: true,
  },
];

export const SUMMARY_CARD_CONFIG = [
  {
    key: "total_orders",
    title: "Total Orders",
    valueKey: "count",
    trends: [
      { changeKey: "previous_day_change", subtitle: "vs previous day" },
      { changeKey: "last_week_change", subtitle: "vs last week" },
    ],
  },
  {
    key: "total_orders_this_week",
    title: "Orders This Week",
    valueKey: "this_week_count",
    trends: [{ changeKey: "last_week_change", subtitle: "vs last week" }],
  },
  {
    key: "delhi_customer_orders",
    title: "Delhi Customers Order",
    valueKey: "count",
    trends: [
      { changeKey: "previous_day_change", subtitle: "vs previous day" },
      { changeKey: "last_week_change", subtitle: "vs last week" },
    ],
  },
  {
    key: "institution_orders",
    title: "Institution Orders",
    valueKey: "count",
    trends: [
      { changeKey: "previous_day_change", subtitle: "vs previous day" },
      { changeKey: "last_week_change", subtitle: "vs last week" },
    ],
  },
  {
    key: "branch_customer_orders",
    title: "Branch Customer Order",
    valueKey: "count",
    trends: [
      { changeKey: "previous_day_change", subtitle: "vs previous day" },
      { changeKey: "last_week_change", subtitle: "vs last week" },
    ],
  },
  {
    key: "progressive_orders",
    title: "Progressive Orders",
    valueKey: "count",
    trends: [
      { changeKey: "previous_day_change", subtitle: "vs previous day" },
      { changeKey: "last_week_change", subtitle: "vs last week" },
    ],
  },
];

export const DEFAULT_LNAM_GROUPS = [
  "FreeForm Progressive",
  "Bifocal",
  "Progressive",
  "Trifocal",
  "Single Vision",
  "Stock",
  "Rx Stock Progressive",
  "Prolux Progressive",
  "FF SimplyPro",
];

export const STATUS_OPTIONS = [
  { label: "All statuses", value: "" },
  { label: "On Hold", value: "on_hold" },
  { label: "Authorization", value: "pending_auth" },
  { label: "Processing", value: "processing" },
];

export const CUSTOMER_CATEGORY_OPTIONS = [
  { label: "All customers", value: "" },
  { label: "Institution", value: "institution" },
  { label: "Branch customer", value: "branch_customer" },
];

export const ORDER_TYPE_OPTIONS = [
  { label: "All types", value: "" },
  { label: "Rx", value: "rx" },
  { label: "Stock", value: "stock" },
];

export const DLAB_OPTIONS = [
  { label: "All", value: "" },
  { label: "DLAB only", value: "true" },
  { label: "Non-DLAB", value: "false" },
];
